interface DateTimeObject {
  date: string
  time: string
}

export const dateTimeObjectToSecondsTimestamp = (dateTime: DateTimeObject) => {
  return new Date(`${dateTime.date} ${dateTime.time}`).getTime() / 1000
}
